import styled from "styled-components";
import Text from "components/Text";

export const PageTitle = styled(Text)`
  font-weight: 700;
  margin: 20px 0;
`;

export const FiltersArea = styled.div.attrs({
  className: "w-100 w-lg-100 px-3 pr-3 py-3 bg-primary pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel"
})`
`;